import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { AxiosError, AxiosResponse } from "axios";
import { CSVLink } from "react-csv";
import { Button, Card, CardBody, CardHeader, Container } from "reactstrap";

import Filters from "../Components/Filter/Filters";
import Header from "../../../components/Headers/Header";
import ReportTypeCard from "../../../components/Custom/ReportTypeCard";
import DotsSpinner from "../../../components/Loader/DotsSpinner/DotsSpinner";

import { State } from "../../../Reducers/types";
import {
  ISelectedFilters,
  TypeWeekAdaptiveAssessmentCount,
} from "../../../types";
import {
  getAdaptiveAssessmentCount,
  getStudentAvgAppUsage,
  getTeacherNudges,
} from "../../../Services/Reports/ReportService";
import moment from "moment";
import Filter from "../Components/Filter/Filter";

export default function WeeklyReports() {
  const refDownloadFile = useRef<any>();
  const [reportfilter, setReportFilter] = useState<ISelectedFilters>();
  // const reportfilter = useSelector(
  //   (state: State) => state.reportFilter.reportFilter
  // );
  const session = useSelector((state: any) => state?.user?.session?.id);

  const [reportData, setReportData] = useState<any>(null); // stores report data
  const [fileName, setFileName] = useState<string>(""); // stores the file name to be exported as csv

  // data states for the report
  // const [adaptiveAssessmentCount, setAdaptiveAssessmentCount] = React.useState<TypeWeekAdaptiveAssessmentCount[]>([]); // stores data related to adaptative assessment

  // loading
  const [isDownloadingReport, setIsDownloadingReport] =
    useState<boolean>(false); // for download file loader

  // fetch this week's adaptive assessment counts - for learning gap / remedial pathway
  const fetchAdaptiveAssessmentCounts = (type: string) => {
    setIsDownloadingReport(true);
    getAdaptiveAssessmentCount(
      session,
      reportfilter.schoolId,
      // "2021-12-19",
      // reportfilter?.end_date,
      moment().subtract(7, "d").format("YYYY-MM-DD"),
      // "2021-12-25",
      moment().format("YYYY-MM-DD"),
      500,
      0
    ).then(
      (response: AxiosResponse) => {
        // console.log("Response for adaptive assessment counts: ", response?.data?.data);
        // setAdaptiveAssessmentCount(response?.data?.data);

        let data = response?.data?.data?.map((each) => ({
          srn_no: each?.srn_no || 0,
          first_name: each?.first_name || "Not Available",
          last_name: each?.last_name || "Not Available",
          school_name: each?.school_name || "Not Available",
          grade: each?.grade || "Not Available",
          section: each?.section || "Not Available",
          block: each?.block || "Not Available",
          district: each?.district || "Not Available",
          date_range: `${
            moment("2021-12-04").format("MMM Do YYYY") +
            " - " +
            moment(reportfilter?.date?.end_date).format("MMM Do YYYY")
          }`,
          adaptive_assessment_count: each?.adaptive_assessment_count || 0,
        }));
        let labels = [
          { label: "SRN Number", key: "srn_no" },
          { label: "First Name", key: "first_name" },
          { label: "Last Name", key: "last_name" },
          { label: "School Name", key: "school_name" },
          { label: "Grade", key: "grade" },
          { label: "Section", key: "section" },
          { label: "Block", key: "block" },
          { label: "District", key: "district" },
          { label: "Date Range", key: "date_range" },
          { label: "Assessment Count", key: "adaptive_assessment_count" },
        ];

        let file_name: string =
          // ${
          //     reportfilter.school?.name
          //   }-
          type === "learning_gap"
            ? `Student-Learning-Gap-Report-${moment().format("DD-MM-YYYY")}`
            : `Student-Remedial-Pathway-Report-${moment().format(
                "DD-MM-YYYY"
              )}`;

        generateReport(data, labels, file_name);
      },
      (error) => {
        console.log(
          "Error for adaptive assessment counts: ",
          error?.response?.data
        );
      }
    );
  };

  // fetch student avg. app usage
  // const fetchStudentAppUsage = () => {
  //   setIsDownloadingReport(true);

  //   getStudentAvgAppUsage(
  //     200,
  //     0,
  //     1,
  //     reportfilter?.district?.id,
  //     reportfilter?.block?.id,
  //     reportfilter.school.id,
  //     0,
  //     "2021-12-04",
  //     "reportfilter?.end_date"
  //   ).then(
  //     (response: AxiosResponse) => {
  //       // console.log("Response for student avg. app usage: ", response?.data?.data);
  //       let data = response?.data?.data?.map((each) => ({
  //         srn_no: each?.srn_no || 0,
  //         first_name: each?.first_name || "Not Available",
  //         last_name: each?.last_name || "Not Available",
  //         school_name: each?.school_name || "Not Available",
  //         grade: each?.grade || "Not Available",
  //         section: each?.section || "Not Available",
  //         district: each?.district || "Not Available",
  //         block: each?.block || "Not Available",
  //         date_range: `${
  //           moment("2021-12-04").format("MMM Do YYYY") +
  //           " - " +
  //           moment(reportfilter?.end_date).format("MMM Do YYYY")
  //         }`,
  //         usage_min: (each?.usage_min / 60).toFixed(2) || 0,
  //       }));
  //       let labels = [
  //         { label: "SRN Number", key: "srn_no" },
  //         { label: "First Name", key: "first_name" },
  //         { label: "Last Name", key: "last_name" },
  //         { label: "School Name", key: "school_name" },
  //         { label: "Grade", key: "grade" },
  //         { label: "Section", key: "section" },
  //         { label: "District", key: "district" },
  //         { label: "Block", key: "block" },
  //         { label: "Date Range", key: "date_range" },
  //         { label: "Usage (hours)", key: "usage_min" },
  //       ];

  //       generateReport(
  //         data,
  //         labels,
  //         `Student-App-Usage-Report-${
  //           reportfilter.school?.name
  //         }-${moment().format("DD-MM-YYYY")}`
  //       );
  //     },
  //     (error) => {
  //       console.log(
  //         "Error for student avg. app usage: ",
  //         error?.response?.data
  //       );
  //     }
  //   );
  // };

  // fetch teacher nudges
  const fetchTeacherNudges = () => {
    setIsDownloadingReport(true);

    getTeacherNudges(reportfilter?.schoolId).then(
      (response: AxiosResponse) => {
        // console.log("Response for teacher nudges: ", response?.data?.data);
        let data = response?.data?.data?.map((each) => ({
          emp_code: each?.emp_code || "Not Available",
          first_name: each?.first_name || "Not Available",
          last_name: each?.last_name || "Not Available",
          school_name: each?.school_name || "Not Available",
          block: each?.block || "Not Available",
          district: each?.district || "Not Available",
          date_range: `${
            moment("2021-12-04").format("MMM Do YYYY") +
            " - " +
            moment(reportfilter?.date?.end_date).format("MMM Do YYYY")
          }`,
          nudges: each?.nudges || 0,
        }));
        let labels = [
          { label: "Employee Code", key: "emp_code" },
          { label: "First Name", key: "first_name" },
          { label: "Last Name", key: "last_name" },
          { label: "School Name", key: "school_name" },
          { label: "Block", key: "block" },
          { label: "District", key: "district" },
          { label: "Date Range", key: "date_range" },
          { label: "Nudges", key: "nudges" },
        ];

        generateReport(
          data,
          labels,
          `Teacher-Nudges-Report-${moment().format("DD-MM-YYYY")}`
        );
      },
      (error: AxiosError) => {
        console.log("Error for teacher nudges: ", error?.response?.data);
      }
    );
  };

  // generates report for tickets (Grievance, Query, Support)
  const generateReport = (data, labels, file_name) => {
    setFileName(file_name);

    // form data to download CSV
    let listData = data;
    let header = labels;
    // console.log("Data: ", listData, " Header: ", header);
    setReportData((oldData) => ({
      ...oldData,
      data: listData,
      headers: header,
    }));
    setIsDownloadingReport(false);
    refDownloadFile?.current?.getElementsByTagName("a")[0]?.click();
  };

  return (
    <React.Fragment>
      <Header />

      {/* STAT CARDS */}
      {/* <Container className="mt--9" fluid>
    <Row>
        <Col lg="6" xl="3" sm="12">
            <DashboardStatCard
                title={'Total Students'}
                stats={totalItemCount === 0 ? 0 : totalItemCount}
                icon={'fas fa-users'}
                iconColor={'text-muted'}
                label={'Toal students'}
            />
        </Col>
    </Row>
</Container> */}

      <Container className="mt--9" fluid>
        <Card className="mb-4 mb-xl-0">
          <CardHeader className="border-0">
            <div className="d-flex justify-content-between">
              <h3 className="mb-0 text-muted">
                <i className="fas fa-file-invoice mr-1"></i> Weekly Reports
              </h3>
              <div>
                {/* {studentImprovement?.length !== 0 ?
                                    <Button
                                        color="primary"
                                        size="sm"
                                        className="mr-2"
                                        disabled={isDownloadingReport}
                                        onClick={() => { handleDownloadReport(1) }}
                                    >Download File <i className="fas fa-file-download"></i></Button>
                                    : <></>} */}
              </div>
            </div>

            <div className="pt-2">
              {/* <Filters
                timeFilter={false}
                gradeFilter={false}
                weekMonth={false}
              /> */}
              <Filter
                // hasGradeFilter
                hasDistrictFilter
                hasBlockFilter
                hasSchoolFilter
                onSearch={(selectedFilters) => {
                  if (
                    selectedFilters.blockId &&
                    selectedFilters.districtId &&
                    selectedFilters.schoolId
                  ) {
                    setReportFilter(selectedFilters);
                  }
                }}
                onClear={() => {}}
              />
            </div>
          </CardHeader>

          <CardBody>
            <div className="d-flex justify-content-center">
              <button ref={refDownloadFile} className="d-none">
                <CSVLink
                  data={reportData?.data ? reportData?.data : []}
                  headers={reportData?.headers ? reportData?.headers : []}
                  filename={`${fileName}.csv`}
                >
                  Download List <i className="fas fa-file-download ml-1"></i>
                </CSVLink>
              </button>
            </div>
            {/* {moment().startOf('isoWeek').format('MMMM Do YYYY')} - {moment().endOf('isoWeek').format('MMMM Do YYYY')} */}
            {reportfilter?.schoolId ? (
              <div className="reports-grid">
                {!isDownloadingReport ? (
                  <ReportTypeCard
                    title="Learning Gap"
                    description="Students receiving a learning gap report"
                    navigateTo={() =>
                      fetchAdaptiveAssessmentCounts("learning_gap")
                    }
                  />
                ) : (
                  <DotsSpinner />
                )}

                {/* {!isDownloadingReport ? <ReportTypeCard
                                title="App Usage"
                                description="Avg. time spent by each student on the PAL app"
                                navigateTo={() => fetchStudentAppUsage()}
                            /> : <DotsSpinner />} */}

                {!isDownloadingReport ? (
                  <ReportTypeCard
                    title="Remedial Pathway"
                    description="Students with remedial pathways assigned"
                    navigateTo={() =>
                      fetchAdaptiveAssessmentCounts("remedial_pathway")
                    }
                  />
                ) : (
                  <DotsSpinner />
                )}

                {!isDownloadingReport ? (
                  <ReportTypeCard
                    title="Teacher Nudges"
                    description="Data backed nudges generated for teachers"
                    navigateTo={() => fetchTeacherNudges()}
                  />
                ) : (
                  <DotsSpinner />
                )}
              </div>
            ) : (
              <div className="d-flex justify-content-center text-muted">
                Please Select A Block Then A School To Generate Reports
              </div>
            )}
          </CardBody>
        </Card>
      </Container>
    </React.Fragment>
  );
}
